import { ProductState, ProductResponseProps } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getProductList } from './product.services';

export const initialState: ProductState = {
    data: {} as ProductResponseProps,
    status: "loading",
    error: {}
}

export const ProductSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProductList.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getProductList.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getProductList.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const ProductReducer = ProductSlice.reducer